export default {
	SUCCESS: "success",
	ERROR: "error",
	WARNING: "warning",
	INFO: "info"
}
